export enum DateSearchParameter {
	DateTo = 'dateTo',
	DateFrom = 'dateFrom',
}
